import React, { useState, useEffect, useRef, useCallback } from 'react';
import 'react-phone-number-input/style.css';
import { useNavigate, useParams } from 'react-router';
import Scroller from 'ui-component/Scroller';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from 'store/reducers/mainSlice';
import { FaPlus, FaSave, FaSpinner } from 'react-icons/fa';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import ReactSelect from 'react-select';
import usePageTitle from 'hooks/usePageTitle';
import { useDropzone } from 'react-dropzone';
import toast from 'react-hot-toast';
import { Skeleton } from '@mui/material';
import useIsMobile from 'utils/isMobileUtils';
import { CloseIcon, PlusIcon, InfoIcon, ChevronLeftIcon } from 'ui-component/custom-icons/icons';  



const SettingsCompanyDetails = ({ edit }) => {
	const { id } = useParams();
    const [setPageTitle] = usePageTitle('Settings');
    useEffect(() => {
        return () => {
            setPageTitle('Settings');
        };
	}, []);
	const [isDataLoaded, setIsDataLoaded] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [isFormProcessing, setIsFormProcessing] = useState(false);
	const history = useNavigate();
    const [countryList, setCountryList] = useState([]);

	const [companyDetails, setCompanyDetails] = useState({
		id: '',
		name: '',
		address: '',
		zipCode: '',
		city: '',
		countryId: '',
		countryName: '',
		email: '',
		emailInvoice: '',
		contactNumber: '',
		website: '',
		vatNumber: '',
		logoUrl: '',
	});

	useEffect(() => {
		initializeData()
	}, []);

	const initializeData = () => {
		// setLoading(true);

        api.getSelectOptionsList('country').then((res) => {
            const collection = res?.data?.map((item) => ({ id: item.id, label: item.name, value: item.id }));
            setCountryList(collection);
		});
		
		api.getCompanyDetails().then((res) => {
			setLoading(false);
			if (res.status) {
				setCompanyDetails({
					...companyDetails,
					id: res.data?.id,
					name: res.data?.name,
					address: res.data?.address,
					zipCode: res.data?.zip_code,
					city: res.data?.city,
					countryId: res.data?.country?.id,
					countryName: res.data?.country?.name,
					email: res.data?.email,
					emailInvoice: res.data?.email_invoice,
					contactNumber: res.data?.contact_number,
					website: res.data?.website,
					vatNumber: res.data?.vat_number,
					logoUrl: res.data?.logo_url,
				})
				setIsDataLoaded(true);
				setIsLoading(false)
			}
		});
	}


	const dispatch = useDispatch();
	const nameRef = useRef();
	const [alertMessage, setAlertmessage] = useState({});
	const [warehouseInfo, setWarehouseInfo] = useState({
		name: '',
		canAcceptOrders: 0,
		isDefault: 0,
		canIncludeStock: 0,
		priority: '',
		status: 0,
	});
	const [vatValidationAlert, setVatvalidationlert] = useState();
	const namehandle = (e) => {
		let inputValue = e.target.value;
		const words = inputValue.split(' ');
		const capitalizedWords = words.map((word) => word.charAt(0).toUpperCase() + word.substr(1));
		inputValue = capitalizedWords.join(' ');
		e.target.value = inputValue;
	};
	const handleChange = (val) => {
		setWarehouseInfo(val);
	};

	const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);

	// const onDrop = useCallback((acceptedFiles) => {
	// 	// if (validateFileExtensionforLogo(acceptedFiles[0].name)) {
	// 	// 	setData((prevData) => ({ ...prevData, companyLogo: acceptedFiles[0] }));
	// 	// 	setLogo(acceptedFiles[0].name);
	// 	// } else {
	// 		toast.error('Invalid file extension. Please select a WEBP, JPEG, JPG, or PNG file.');
	// 	// }
	// }, []);

	// const { getRootProps, getInputProps } = useDropzone({
	// 	onDrop,
	// 	accept: '.webp, .jpeg, .jpg, .png',
	// 	multiple: false
	// });

	
    const uploadAttachment = async (attachment) => {
        const formData = new FormData();
        formData.append('attachment', attachment);
        // formData.append('purchase_invoice_id', purchaseInvoice?.id);
        // formData.append('type', 'payment');

        try {

			toast.promise(
				api
					.uploadCompanyDetailsLogo(id, formData)
					.then(
						(res) => {
							if (res.status) {
                                initializeData();
								restartCookies()
								// setEstimaterow((oldData) => ({
								// 	...oldData,
								// 	notes: [
								// 		{
								// 			id: res?.data?.id,
								// 			details: noteInputValue,
								// 			date: moment(res?.data?.created_at).format('YYYY-MM-DD'),
								// 			time: moment(res?.data?.created_at).format('HH:mm'),
								// 			user_name: userName,
								// 			expand: false
								// 		},
								// 		...oldData?.notes
								// 	]
								// }));
							}

							return res?.status ? res : null;
						},
						() => {}
					),
				{
					loading: 'uploading file...',
					success: (data) => `${data.message}`,
					error: <b>Failed to upload file</b>
				}
            );
            
        } catch (error) {
            toast.error('Error uploading file');
        }
    };
    
    const allowedExtensions = ['webp', 'jpeg', 'jpg', 'png', 'svg'];
    const validateFileExtension = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();
        return allowedExtensions.includes(extension);
	};
	
	const onAttachmentDrop = useCallback((acceptedFiles) => {
		

		const file = acceptedFiles[0];
		if (!file) return;
		if (!validateFileExtension(file.name)) {
			toast.error('Invalid file extension. Please select a WEBP, JPEG, JPG, or PNG file.');
			return;
		}
		if (file.size > 5 * 1024 * 1024) {
			toast.error('File size should not exceed more than 5MB.');
			return;
		}
		let sizeStr = '';
		if (file.size >= 1024 * 1024) {
			sizeStr = (file.size / (1024 * 1024)).toFixed(2) + ' MB';
		} else {
			sizeStr = (file.size / 1024).toFixed(2) + ' KB';
		}
		let values = {
			filename: file.name,
			size: sizeStr,
			extension: file.type,
		}


		uploadAttachment(file);

        // if (validateFileExtension(acceptedFiles[0].name)) {
        //     uploadAttachment(acceptedFiles[0]);
		// 	// setPaymentData((prevData) => ({ ...prevData, attachment: acceptedFiles[0] }));
		// 	// setPaymentAttachment(acceptedFiles[0].name);
		// } else {
		// 	toast.error('Invalid file extension. Please select a WEBP, JPEG, JPG, or PNG file.');
		// }
	}, []);

	const { getRootProps: getAttachmentRootProps, getInputProps: getAttachmentInputProps } = useDropzone({ onDrop: onAttachmentDrop });

	const contactTypes = [
		{ label: 'Customer', value: 'customer' },
		{ label: 'Lead', value: 'lead' },
		{ label: 'Supplier', value: 'supplier' },
		{ label: 'Transit Company', value: 'transit-company' }
	];

	
	const getCookie = (name) => {
		const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		if (match) return JSON.parse(decodeURIComponent(match[2]));
		return null;
	};
	const setCookie = (name, value, days = 7) => {
		const expires = new Date(Date.now() + days*24*60*60*1000).toUTCString();
		document.cookie = `${name}=${encodeURIComponent(JSON.stringify(value))}; expires=${expires}; path=/`;
	};
	const removeCookie = (name) => {
		document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
	};
	const restartCookies = () => {
		removeCookie('invoiceSettingsDetails');
		api.getSettings().then((res) => {
			setCookie('invoiceSettingsDetails', res?.data);
		});
	};
	const handleSubmit = (e) => {
		if (companyDetails?.name?.trim() === '' || companyDetails?.name === null) {
			toast.error('Company name is required');
			return false;
		} else if (companyDetails?.address?.trim() === '' || companyDetails?.address === null) {
			toast.error('Address is required');
			return false;
		} else if (companyDetails?.zipCode?.trim() === '' || companyDetails?.zipCode === null) {
			toast.error('Zip code is required');
			return false;
		} else if (companyDetails?.city?.trim() === '' || companyDetails?.city === null) {
			toast.error('City is required');
			return false;
		} else if (companyDetails?.countryId === '' || companyDetails?.countryId === undefined) {
			toast.error('Country is required');
			return false;
		} else if (companyDetails?.email?.trim() === '' || companyDetails?.email === null) {
			toast.error('Email is required');
			return false;
		} else if (companyDetails?.emailInvoice?.trim() === '' || companyDetails?.emailInvoice === null) {
			toast.error('Email for invoices is required');
			return false;
		} else if (companyDetails?.contactNumber?.trim() === '' || companyDetails?.contactNumber === null) {
			toast.error('Contact number is required');
			return false;
		} else {
			setIsFormProcessing(true)

			toast.promise(
				api
					.updateCompanyDetails(companyDetails)
					.then(
						(res) => {
							setIsFormProcessing(false)
							restartCookies()
							return res?.status ? res : null;
						},
						() => {
							setIsSubmitDisabled(false);
						}
					),
				{
					loading: 'Updating Company Details...',
					success: (data) => `${data.message}`,
					error: <b>Failed to update company details</b>
				}
			);
		}

	};

	const isMobile = useIsMobile();
	
	return (
		<>
			<div className="row">
				<div
					className={`col-xl-10 col-lg-10 offset-xl-1 offset-lg-1 col-md-10 offset-md-1 col-12 ${isMobile ? '' : 'mb20'}`}
					style={{
						marginTop: '10px'
					}}
				>
					<div className="row">

						<div className="col-12" style={{ marginBottom: '10px'}}>

							<button
								type="button"
								className="btn btn-primary btn-outlined-main white-var"
								style={{ minWidth: 'unset' }}
								onClick={() => {
									history(-1);
								}}
							>
								<ChevronLeftIcon /> Go Back to Settings
							</button>
						</div>
					</div>
					<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
						<div className="header-bubble" />
						<div className="d-flex flex-column " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
							<div
								style={{
									position: 'relative',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									marginBottom: 8,
									minHeight: 38 // ensures enough height for the button
								}}
							>
								<button
									type="button"
									aria-label="Back"
									onClick={() => history(-1)}
									className="circle-back-btn"
									style={{
										position: 'absolute',
										left: 20,
										top: '50%',
										transform: 'translateY(-50%)'
									}}
								>
									{/* Replace with your fi arrow icon, example below */}
									<svg width="22" height="22" fill="none" viewBox="0 0 24 24">
										<path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
									</svg>
								</button>
								<h5
									style={{
										textAlign: 'center',
										flex: 1,
										margin: 0,
										display: 'flex',
										gap: 10,
										justifyContent: 'center',
										alignItems: 'center'
									}}
								>
									Company Details
								</h5>
							</div>
							<div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
								<button
									type="button"
									className="btn btn-main"
									disabled={!isDataLoaded || isFormProcessing}
									onClick={() => {
										if (!isFormProcessing) {
											handleSubmit();
										}
									}}
								>
									{isFormProcessing ? (
										<>
											<FaSpinner className="fa-spin" /> Saving...
										</>
									) : (
										<>
											<FaSave /> Save Details
										</>
									)}
								</button>
							</div>
						</div>
					</div>
					<div className={`${isMobile ? 'mobile-scroll-container ' : 'card w-100 h-100'}`}>
						<div className={`${isMobile ? '' : 'card-body'}`}>
							<div className="section-head m-0 p-0 hide-on-mobile">
								<h5 className="m-0 p-0 pb-2" style={{ fontWeight: '500' }}>
									Company Details
								</h5>
							</div>
							<Scroller>
								<div className="form-section">
									<div className="form-section-head"></div>

									<div className="form-group-error">
										{alertMessage.contactType && (
											<>
												<span className="error-message text-danger">{alertMessage.contactType}</span>
											</>
										)}
									</div>
								</div>
								<div className="row">
									<div className="col-lg-4 col-md-4 col-12">
										<div className="text-right">
											<label htmlFor="">
												Company name <sup className="text-danger">*</sup>
											</label>
										</div>
									</div>
									<div className="col-lg-6 col-md-6 col-12 form-group">
										{
											isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={30} />
												</div>
											) : (
												<input
													type="text"
													className="form-control"
													id="inputName"
													value={companyDetails?.name}
													onChange={(e) => {
														setCompanyDetails({ ...companyDetails, name: e.target.value });
													}}
												/>
											)
										}
									</div>
								</div>

								<div className="row">
									<div className="col-lg-4 col-md-4 col-12">
										<div className="text-right">
											<label htmlFor="">
												Address <sup className="text-danger">*</sup>
											</label>
										</div>
									</div>
									<div className="col-lg-6 col-md-6 col-12 form-group">
										{
											isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={30} />
												</div>
											) : (

												<input
													type="text"
													className="form-control"
													id="inputName"
													value={companyDetails?.address}
													onChange={(e) => {
														setCompanyDetails({ ...companyDetails, address: e.target.value });
													}}
												/>
											)
										}
									</div>
								</div>

								<div className="row">
									<div className="col-lg-4 col-md-4 col-12">
										<div className="text-right">
											<label htmlFor="">
												Zip code <sup className="text-danger">*</sup>
											</label>
										</div>
									</div>
									<div className="col-lg-6 col-md-6 col-12 form-group">
										{
											isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={30} />
												</div>
											) : (

												<input
													ref={nameRef}
													type="text"
													className="form-control"
													id="inputName"
													maxLength={50}
													value={companyDetails?.zipCode}
													onChange={(e) => {
														setCompanyDetails({ ...companyDetails, zipCode: e.target.value });
													}}
												/>
											)
										}
									</div>
								</div>

								<div className="row">
									<div className="col-lg-4 col-md-4 col-12">
										<div className="text-right">
											<label htmlFor="">
												City <sup className="text-danger">*</sup>
											</label>
										</div>
									</div>
									<div className="col-lg-6 col-md-6 col-12 form-group">
										{
											isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={30} />
												</div>
											) : (

												<input
													ref={nameRef}
													type="text"
													className="form-control"
													id="inputName"
													value={companyDetails?.city}
													onChange={(e) => {
														setCompanyDetails({ ...companyDetails, city: e.target.value });
													}}
												/>
											)
										}
									</div>
								</div>

								<div className="row">
									<div className="col-lg-4 col-md-4 col-12">
										<div className="text-right">
											<label htmlFor="">
												Country <sup className="text-danger">*</sup>
											</label>
										</div>
									</div>
									<div className="col-lg-6 col-md-6 col-12 form-group">
										{
											isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={30} />
												</div>
											) : (

												<ReactSelect
													className="rs-container"
													classNamePrefix="rs"
													name="transit-company"
													options={countryList}
													value={countryList?.find((c) => c?.value == companyDetails?.countryId)}
													onChange={(e) => {
														setCompanyDetails({ ...companyDetails, countryId: e?.value, countryName: e?.label });
													}}
													menuPlacement="auto"
													menuPosition="fixed"
													placeholder="Select or Type..."
													style={{ borderRadius: '18px' }}
												/>
											)
										}
									</div>
								</div>

								<div className="row">
									<div className="col-lg-4 col-md-4 col-12">
										<div className="text-right">
											<label htmlFor="">
												Email address <sup className="text-danger">*</sup>
											</label>
										</div>
									</div>
									<div className="col-lg-6 col-md-6 col-12 form-group">
										{
											isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={30} />
												</div>
											) : (

												<input
													ref={nameRef}
													type="text"
													className="form-control"
													id="inputName"
													value={companyDetails?.email}
													onChange={(e) => {
														setCompanyDetails({ ...companyDetails, email: e.target.value });
													}}
												/>
											)
										}
									</div>
								</div>

								<div className="row">
									<div className="col-lg-4 col-md-4 col-12">
										<div className="text-right">
											<label htmlFor="">
												Email address for invoices <sup className="text-danger">*</sup>
											</label>
										</div>
									</div>
									<div className="col-lg-6 col-md-6 col-12 form-group">
										{
											isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={30} />
												</div>
											) : (

												<input
													ref={nameRef}
													type="text"
													className="form-control"
													id="inputName"
													value={companyDetails?.emailInvoice}
													onChange={(e) => {
														setCompanyDetails({ ...companyDetails, emailInvoice: e.target.value });
													}}
												/>
											)
										}
									</div>
								</div>

								<div className="row">
									<div className="col-lg-4 col-md-4 col-12">
										<div className="text-right">
											<label htmlFor="">
												Contact number <sup className="text-danger">*</sup>
											</label>
										</div>
									</div>
									<div className="col-lg-6 col-md-6 col-12 form-group">
										{
											isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={30} />
												</div>
											) : (

												<input
													ref={nameRef}
													type="text"
													className="form-control"
													id="inputName"
													value={companyDetails?.contactNumber}
													onChange={(e) => {
														setCompanyDetails({ ...companyDetails, contactNumber: e.target.value });
													}}
												/>
											)
										}
									</div>
								</div>

								<div className="row">
									<div className="col-lg-4 col-md-4 col-12">
										<div className="text-right">
											<label htmlFor="">VAT number</label>
										</div>
									</div>
									<div className="col-lg-6 col-md-6 col-12 form-group">
										{
											isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={30} />
												</div>
											) : (

												<input
													ref={nameRef}
													type="text"
													className="form-control"
													id="inputName"
													value={companyDetails?.vatNumber}
													onChange={(e) => {
														setCompanyDetails({ ...companyDetails, vatNumber: e.target.value });
													}}
												/>
											)
										}
									</div>
								</div>

								<div className="row">
									<div className="col-lg-4 col-md-4 col-12">
										<div className="text-right">
											<label htmlFor="">Website</label>
										</div>
									</div>
									<div className="col-lg-6 col-md-6 col-12 form-group">
										{
											isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={30} />
												</div>
											) : (

												<input
													ref={nameRef}
													type="text"
													className="form-control"
													id="inputName"
													value={companyDetails?.website}
													onChange={(e) => {
														setCompanyDetails({ ...companyDetails, website: e.target.value });
													}}
												/>
											)
										}
									</div>
								</div>

								<div className="row">
									<div className="col-lg-4 col-md-4 col-12">
										<div className="text-right">
											<label htmlFor="">Logo</label>
										</div>
									</div>
									<div className="col-lg-6 col-md-6 col-12 form-group">
										{
											isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={80} />
												</div>
											) : (
												companyDetails?.logoUrl ? (
													<div>
														<div className="card card-shadow">
															<div
																className="settings-logo-delete-container"
																onClick={() => {
																	setCompanyDetails({ ...companyDetails, logoUrl: '' });
																}}
															>
																<CloseIcon height="13px" width="13px" />
															</div>
															<div className="card-body">
																<img src={companyDetails?.logoUrl} className="img-fluid" />
															</div>
														</div>
													</div>
												) : (
													<div {...getAttachmentRootProps()}>
														<div className="add-item-empty-div" style={{ alignItems: 'center' }}>
															<div
																className="text-primary"
																style={{
																	marginTop: '1px',
																	padding: '5px 7px',
																	border: '2px solid #9e9e9e',
																	borderRadius: '32px',
																}}
															>
																<PlusIcon height="16px" width="16px" />
															</div>
															<div style={{ marginLeft: '10px' }}>
																<div
																	className='flex'
																	style={{
																		gap: '5px'
																	}}
																>
																	<span className="fw-500" style={{ fontSize: '12px' }}>Drag & Drop or Click to Upload</span>
																	<span className="text-gray-700" style={{ fontSize: '12px' }}>OR</span>
																	<span className="text-blue-600 fw-500" style={{ fontSize: '12px' }}>Browse Files</span>
																</div>
																<div className="text-gray-600 fw-400 mt-1 flex align-items-center" style={{ fontSize: '10px', gap: '5px' }}>
																	<InfoIcon width='14px' height='14px' />
																	<span style={{ fontSize: '10px' }}>
																		png, jpg, jpeg or webp (Max file size: 5MB)
																	</span>
																</div>
															</div>
														</div>
														<input {...getAttachmentInputProps({ disabled: false })} style={{ display: 'none' }} />{' '}
													</div>
												)
											)
										}
									</div>
								</div>

								{!isMobile && (

									<div className="row">
										<div className="col-12 text-center d-flex align-items-center justify-content-center">
											{
												isLoading ? (
													<div style={{ width: '150px' }}>
														<Skeleton variant="rounded" width={'100%'} height={30} />
													</div>
												) : (
													<button
														type="button"
														className="btn btn-main"
														disabled={isLoading || isFormProcessing}
														onClick={() => {
															if (!isFormProcessing) {
																handleSubmit();
															}
														}}
													>
														{isFormProcessing ? (
															<>
																<FaSpinner className="fa-spin" /> Saving...
															</>
														) : (
															<>
																<FaSave /> Save Details
															</>
														)}
													</button>
												)
											}
										</div>
									</div>
									
								)}
							</Scroller>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default SettingsCompanyDetails;
